import { createContext } from 'preact';
import { useContext } from 'preact/hooks';

/**
 * Provides the current activity's back action to descendant page wrappers.
 *
 * This is given to each activity independently, so each tab's details page
 * can read the correct back action for its own activity stack.
 *
 * The navigation state itself lives in the JourneyWidgetTabs reducer. This
 * context only carries the already-bound callback so shared details-page UI can
 * render a back control without receiving tab-specific props.
 * This means that the details page doesn't need to know which tab it's in
 * and doesn't need to receive the dispatch function or page state as props.
 */
export const JourneyWidgetBackContext = createContext<(() => void) | null>(
  null,
);

/**
 * Returns the nearest back action for the active journey-widget subtree.
 *
 * useContext here means that Peact will search up the component tree for the closest
 * JourneyWidgetBackContext.Provider and return its value, which is the back action function.
 */
export function useJourneyWidgetBackAction(): (() => void) | null {
  return useContext(JourneyWidgetBackContext);
}
